<template>
  <div class="inner-header">
    <div class="title">
      <h3>UEFA Toolkit</h3>
      <transition name="fade" mode="out-in">
        <h1 v-if="scenarioId" :key="scenarioId">{{scenarioData.name}}</h1>
      </transition>
      <!-- <transition name="fade" mode="out-in">
        <h2 v-if="playlistId" :key="playlistId">{{playlistData.name}}</h2>
      </transition> -->
    </div>

    <div class="description" v-if="scenarioId && scenarioData.description">
      <div v-html="excerpt" class="description-text"></div>
      <span 
        v-if="scenarioData.description.length > charLimit"
        @click="openInfoModal"
        class="read-more"
        >Read more</span>
    </div>

    <div class="session-information">
      <ul>
        <li><i class="material-icons">timer</i><span class="label">Time remaining</span> <span class="value">{{timeRemainingConverted}}</span></li>
        <li><i class="material-icons">people</i><span class="label">Participants</span> <span class="value">1</span></li>
        <li><i class="material-icons">account_circle</i><span class="label">Trainer</span> <span class="value" v-html="trainerName"></span></li>
        <li v-if="scenarioId"><button  @click="openInfoModal" class="read-more-mobile"><i class="material-icons">info</i></button></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "ScenarioHeader",
  mixins: [scenarioMixin],
  data () {
    return {
      timeRemaining: null,
      charLimit: 200
    }
  },
  mounted () {
    this.timeRemaining = 60 * 60
    this.countDown();
  },
  methods: {
    countDown () {
      if ( this.timeRemaining >= 0 ) {
        setTimeout(() => {
          this.timeRemaining--
          this.countDown();
        }, 1000);
      }
    },
    openInfoModal () {
      this.$store.dispatch('modalModule/setActive', { 
        type: "description", 
        id: this.scenarioId, 
        description: this.scenarioData.description, 
        name: this.scenarioData.name,
        dateCreated: this.scenarioData.dateCreated,
        createdBy: this.scenarioData.createdBy,
        language: this.scenarioData.language
      })
    }
  },
  computed: {
    authorized () {
      return this.$store.state.traineeStatusModule.authorized
    },
    trainerName () {
      return (this.scenarioData ? this.scenarioData.trainer.name : '')
    },
    timeRemainingConverted () {
      const format = val => `0${Math.floor(val)}`.slice(-2)
      let timeArray = [];
      if (this.timeRemaining > 3600) {
        timeArray.push(this.timeRemaining / 3600)  
      } 
      timeArray.push((this.timeRemaining % 3600) / 60);
      timeArray.push(this.timeRemaining % 60);

      return timeArray.map(format).join(':')
    },
    excerpt () {
      if ( this.scenarioData.description && this.scenarioData.description.length > this.charLimit ) {
        return this.scenarioData.description.substring(0, this.charLimit) + '... '
      } else {
        return this.scenarioData.description
      }
    }
  },
  watch: {
    scenarioId () {
      if ( this.scenarioData) {
        this.timeRemaining = this.scenarioData.duration
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100vw;
  overflow-x: hidden;
}

h1 {
  font-size: 24px;
}

.inner-header {
  color: #fff;
  padding: 80px 50px 0 15px;
  // max-width: 940px;
  max-width: var(--container-width);
  margin: 0 auto;
  display: grid;
  grid-template-areas: 
    "title title"
    "info info";
    
  @media all and (min-width: 1024px) {
    padding: 30px 0;
    grid-template-areas: 
      "title title"
      "description info";
  }
}

h3 {
  font-weight: normal;
  color: #fff;
  font-size: 12px;
}
.title {
  grid-area: title;
  margin-bottom: 2em;
}
.description {
  grid-area: description;
  padding-right: 90px;
  
  .read-more {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
}
.read-more-mobile {
  color: #fff;
  display: inline-block;
  text-align: left;
  padding: 0;

  @media all and (min-width: 1024px) {
    display: none;
  }
}
.session-information {
  grid-area: info;
  // flex: 1;
  margin-left: auto;
  font-size: 12px;

  h4 {
    font-size: 16px;
    font-weight: normal;
  }

  ul {
    padding-left: 0;
    margin: 0;
    min-width: 190px;
  }
  li {
    list-style: none;
    display: flex;
    align-items: center;
    color: #fff;
    margin-bottom: 0.3em;

    i {
      margin-right: 10px;
      font-size: 20px;
    }

    .value {
      margin-left: auto;
      color: #fff;
    }
  }
}
@media all and (max-width: 1024px) {
  .session-information .label,
  .description {
    display: none;
  }

  .session-information {
    margin-left: 0;

    ul {
      display: flex;
      li:not(:last-of-type) {
        margin-right: 15px;
      }
    }
  }
}

.description-text /deep/ p {
  margin: 0;
}

</style>